import React from 'react';

import style from './style.module.scss';

const Header = ({ moveOn, closedModalEvent, setSaveInProgressEvent, title }) => {
  return (
    <div className={`${style.header} px-4 md:px-8 py-7`}>
      <p
        className={style.cancelClass}
        onClick={() => {
          moveOn ? setSaveInProgressEvent(true) : closedModalEvent();
        }}
      >
        Cancel
      </p>
      <h1 className={`${style.addClass} h1-semibold`}>{title}</h1>
      <div className={style.invisibleDiv}>Cancel</div>
    </div>
  );
};

export default Header;
